import React, { useEffect, useState } from 'react';
import Organization from './Organization';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import Loader from '../common/Loader';
import { PLEASE_CALL_MESSAGE } from '../../common';

function Dashboard ({ auth, orgs, loadError }) {

   const [organizations, setOrganizations] = useState([]);
   const [isLoaded, setIsLoaded] = useState(false);
   const navigate = useNavigate();

   useEffect(() => {
      if (orgs !== null) {
         setIsLoaded(true);
         setOrganizations(orgs);
      }
   }, [auth.access_token, orgs]);

   function navigateToChangePassword() {
      navigate('/change-password');
   }

   const inactiveOrgMessage = 'The logged in user is not associated to an active organization.'

   const noOrgErrorMessage = 'The logged in user is not associated to an organization.'

   const loadErrorMessage = 'Unable to load your organizations.'

   return (
      loadError ? <div className='main-content'><p>{loadErrorMessage}<br /><br />{PLEASE_CALL_MESSAGE}</p></div> :
      (!isLoaded) ? <Loader message='Loading...' /> :
      <div className='main-content'>
         {
            (auth.user?.force_portal_password_reset) ?
               <div>
                  <h3>You are required to change your password in order to access this site.  You will be sent a password reset email and are being redirected to the reset screen.</h3>
                  <button className="btn btn-primary" onClick={navigateToChangePassword}>
                     Ok
                  </button>
               </div> :
               (!organizations.length) ?
                  <p>{noOrgErrorMessage}<br /><br />{PLEASE_CALL_MESSAGE}</p>
                  :
                  !organizations.some(o => o.is_active) ?
                     <p>{inactiveOrgMessage}<br /><br />{PLEASE_CALL_MESSAGE}</p>
                     :
                     organizations.filter(o => o.is_active).map(
                        org => <Organization name={org.name} key={org.id} id={org.id} owner={org.asset_owner} has_data_sharing={org.allow_datasharing} />
                     )
                  }
      </div>
   );
}

const mapStateToProps = (state) => ({
   auth: state.auth,
   orgs: state.org.orgs,
   loadError: state.org.loadError
})
export default connect(mapStateToProps)(Dashboard);

